const REAL_NATIVE_USER_AGENT_TOKEN = 'ToDoClient';
const DEV_SIM_USER_AGENT_TOKENS = ['ToDoDevSim', 'ToDoClientDevSim'];
const DEV_SIM_SESSION_STORAGE_KEY = 'todo-native-dev-sim-session';

function hasNavigatorUserAgent(): boolean {
  return typeof navigator !== 'undefined' && typeof navigator.userAgent === 'string';
}

export function isNativeDevSimulatorUserAgent(): boolean {
  if (!hasNavigatorUserAgent()) {
    return false;
  }

  return DEV_SIM_USER_AGENT_TOKENS.some((token) => navigator.userAgent.includes(token));
}

export function isNativeClientUserAgent(): boolean {
  return hasNavigatorUserAgent() &&
    navigator.userAgent.includes(REAL_NATIVE_USER_AGENT_TOKEN) &&
    !isNativeDevSimulatorUserAgent();
}

export function isNativeDevSimulatorEnabled(): boolean {
  return isNativeDevSimulatorUserAgent() || (import.meta.env.DEV && import.meta.env.VITE_ENABLE_NATIVE_DEV_SIM === 'true');
}

export function isNativeShellMode(): boolean {
  return isNativeClientUserAgent() || isNativeDevSimulatorEnabled();
}

export function hasNativeDevSimulatorSession(): boolean {
  if (typeof window === 'undefined') {
    return false;
  }

  return window.sessionStorage.getItem(DEV_SIM_SESSION_STORAGE_KEY) === '1';
}

export function setNativeDevSimulatorSession(active: boolean): void {
  if (typeof window === 'undefined') {
    return;
  }

  if (active) {
    window.sessionStorage.setItem(DEV_SIM_SESSION_STORAGE_KEY, '1');
    return;
  }

  window.sessionStorage.removeItem(DEV_SIM_SESSION_STORAGE_KEY);
}
